import styled from 'styled-components';
import Colors from '../../constants/Colors';

const PortfolioBg = styled.div`
  display: grid;
  height: 100%;
  background: ${Colors.darkBlueGray};
`;

const PortfolioBounds = styled.div`
  padding: 10px;
`;

const PortfolioSlider = styled.div`
  display: grid;
  overflow-x: scroll;
`;

const PortfolioGrid = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: column;
  grid-template-columns: repeat(auto-fill, 320px);
  height: 100%;
`;

export { PortfolioBg, PortfolioBounds, PortfolioGrid, PortfolioSlider };



// WEBPACK FOOTER //
// ./src/components/Portfolio/PortfolioUI.tsx